import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";

import * as utils from "./utils";
import { message } from "./utils/resetMessage"; // reset message

import "element-ui/lib/theme-chalk/index.css";
import "./assets/styles/index.css";
import "./permission";

Vue.use(ElementUI);
Vue.prototype.$utils = utils;
Vue.prototype.$message = message;

Vue.config.productionTip = false;

// 查看图片地址前缀
Vue.prototype.$img_url = process.env.VUE_APP_IMAGE_URL;

Vue.prototype.$viewReport = report_url => {
  window.open(process.env.VUE_APP_IMAGE_URL + report_url, "_blank");
};

Vue.filter("formatDate", utils.formatDate);

// 延迟加载
/* eslint-disable */
Vue.prototype.$delay = time => {
  return new Promise(re => {
    setTimeout(() => {
      re();
    }, time);
  });
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
